import styled from 'styled-components'

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const WrapperModal = styled.div`
  width: 560px;
  display: block;
  padding: 25px;
  align-self: center;
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const AlertPanel = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  background-color: ${({ theme }) => theme.ds.colors.attention25};
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 30px;
`
export const StatusButtonPanel = styled.div`
  display: flex;
  max-width: 700px;
  justify-content: space-between;
  gap: 10px;
  margin-top: 35px;
  margin-left: auto;
  button {
    width: 45%;
  }
`
